/* this file is transformed by vux-loader */
/* eslint-disable */
import _defineProperty from "/home/travis/build/moohng/wchat/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/travis/build/moohng/wchat/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.sort";
import { get } from "../../utils/request";
import * as types from "../mutation-types";
import * as api from "../../services/api";
export default {
  namespaced: true,
  state: {
    userContact: []
  },
  getters: {
    userContact: function userContact(state) {
      var list = state.userContact.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
      console.log('------', list);
      /* eslint-disable */
      // const letters = 'ABCDEFGHJKLMNOPQRSTWXYZ'.split('').reverse()
      // const zh = '阿八嚓哒妸发旮哈讥咔垃痳拏噢妑七呥扨它穵夕丫帀'.split('').reverse()
      // const groupList = letters.reduce((pre, curr, index, arr) => {
      //   const group = list.filter(({ name }) => {
      //     return (name.localeCompare(curr.toLowerCase()) >= 0 && name.localeCompare(zh.reverse()[index]) < 0) ||
      //            (name.localeCompare(arr.reverse()[index]) >= 0)
      //   })
      //   group.length ? {
      //     ...pre,
      //     [curr]: group
      //   } : pre
      // }, {})

      return list;
    }
  },
  actions: {
    fetchUserContact: function () {
      var _fetchUserContact = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(_ref) {
        var commit, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commit = _ref.commit;
                _context.prev = 1;
                _context.next = 4;
                return get(api.fetchUserContact);

              case 4:
                data = _context.sent;
                commit(types.SAVE_USER_CONTACT, {
                  userContact: data
                });
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](1);
                console.log('error', _context.t0);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 8]]);
      }));

      function fetchUserContact(_x) {
        return _fetchUserContact.apply(this, arguments);
      }

      return fetchUserContact;
    }()
  },
  mutations: _defineProperty({}, types.SAVE_USER_CONTACT, function (state, _ref2) {
    var userContact = _ref2.userContact;
    state.userContact = userContact;
  })
};